/**
 * Paths of the pages that emailed links open. The server builds links with these
 * and the UI router parses them, so both sides always agree.
 */
export const INVITE_PAGE = "invite";
export const RESET_PASSWORD_PAGE = "reset-password";

export const inviteLinkPath = (token: string): string =>
  `/#/${INVITE_PAGE}?token=${encodeURIComponent(token)}`;

export const resetPasswordLinkPath = (token: string): string =>
  `/#/${RESET_PASSWORD_PAGE}?token=${encodeURIComponent(token)}`;

export const GUEST_WAIVER_PAGE = "guest-waiver";

/** The link a borrower shares so each guest can sign before boarding. */
export const guestWaiverLinkPath = (token: string): string =>
  `/#/${GUEST_WAIVER_PAGE}?token=${encodeURIComponent(token)}`;
